module.exports = __webpack_public_path__ + "static/media/microscope.d7228dcb.png";